import { twMerge } from 'tailwind-merge';
import { FC } from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import useClickActionT2 from '@/tracks/useClickActionT2';
import { MoreLinkStyle } from '@/types/cms';
import { handleCmsJump } from '@/components/component-pool/tools/cms-link';
import { useRouter } from 'next/router';

type Props = {
  btnText?: any;
  className?: string;
  componentPos?: any;
  trackingContext: any;
  properties?: any;
  cmsComponentKey?: any;
  moreLinkStyle: MoreLinkStyle;
};

const SeeMoreBtn: FC<Props> = ({
  btnText,
  className,
  componentPos,
  trackingContext,
  cmsComponentKey,
  properties,
  moreLinkStyle
}: Props) => {
  const router = useRouter();
  const { t } = useTranslation('common');
  const { commonClick } = useClickActionT2();

  const handleSeeMoreBtn = () => {
    commonClick({
      mod_nm: properties?.event_key || cmsComponentKey,
      mod_pos: componentPos,
      co: {
        target_nm: 'explore_more'
      },
      ctx: trackingContext
    });
    handleCmsJump(properties.more_link, router);
  };
  return (
    <div
      className={twMerge(
        classNames(
          'enki-body-2xs-strong cursor-pointer inline-block flex-shrink-0 border border-solid border-surface-100-hairline px-[15px] py-[7px] rounded-full',
          className
        )
      )}
      style={{ color: moreLinkStyle?.color }}
      onClick={handleSeeMoreBtn}>
      {btnText ?? t('see_all')}
    </div>
  );
};

export default SeeMoreBtn;
